import React from 'react';
import { faSteeringWheel } from '@fortawesome/pro-regular-svg-icons/faSteeringWheel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SteeringWheelRegularIconProps {
  className?: string;
  styleName?: string;
}

function SteeringWheelRegularIcon(props: SteeringWheelRegularIconProps) {
  return <FontAwesomeIcon icon={faSteeringWheel} {...props} />;
}

export default SteeringWheelRegularIcon;
